import { render, staticRenderFns } from "./ItsRegistOverheads.vue?vue&type=template&id=8d1e6b1e&scoped=true&"
import script from "./ItsRegistOverheads.vue?vue&type=script&lang=js&"
export * from "./ItsRegistOverheads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1e6b1e",
  null
  
)

export default component.exports